import './styles/StandForm.css';

import type { FormInstance }   from 'antd';
import React                   from 'react';
import { observer }            from 'mobx-react';
import { Col }                 from 'antd';
import { Form }                from 'antd';
import Row                     from 'components/App/Row';
import Input                   from 'components/App/IntlInput';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import { AppFormComponent }    from 'components/App/AppForm';
import handleApiError          from 'utils/handleApiError';
import StandModel              from 'models/StandModel';

interface StandFormProps {
  onSuccess: (model: StandModel) => void;
  model: StandModel;
}

@observer
class StandForm extends AppFormComponent<StandFormProps> {
  public formRef: React.RefObject<FormInstance> = React.createRef<FormInstance>();

  public state: {
    errors: any[];
  } = {
      errors: [],
    };

  public render() {
    const { model } = this.props;

    return (
      <Form
        className="antd-form-custom-style modal-form"
        initialValues={{
          aisle: model.get('aisle'),
          hall: model.get('hall'),
          name: model.get('name'),
          number: model.get('number'),
          standType: model.get('standType'),
          surface: model.get('surface'),
        }}
        ref={this.formRef}
      >
        {this.state.errors.length > 0 && (
          <Row>
            <Col span={24} style={{ color: '#e74c3c' }}>
              <ul>
                {this.state.errors.map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            </Col>
          </Row>
        )}
        <Row>
          <Col lg={12} md={12} sm={12} xl={12} xs={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Enseigne" />}
              labelCol={{ span: 24 }}
              name="name"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Enseigne manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={12} md={12} sm={12} xl={12} xs={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Type de stand" />}
              labelCol={{ span: 24 }}
              name="standType"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col lg={6} md={6} sm={6} xl={6} xs={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Hall" />}
              labelCol={{ span: 24 }}
              name="hall"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={6} md={6} sm={6} xl={6} xs={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Allée" />}
              labelCol={{ span: 24 }}
              name="aisle"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={6} md={6} sm={6} xl={6} xs={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Numéro" />}
              labelCol={{ span: 24 }}
              name="number"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={6} md={6} sm={6} xl={6} xs={24}>
            <Form.Item
              label={<FormattedMessageWrapper id="Surface" />}
              labelCol={{ span: 24 }}
              name="surface"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }

  public submit = async () => {
    const {
      model,
      onSuccess,
    } = this.props;

    const values = await this.formRef.current?.validateFields();

    try {
      await model.patch(values);
      if (onSuccess) {
        onSuccess(model);
      }
    } catch (error) {
      handleApiError(error);
    }
  };
}

export default StandForm;
